import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import Logo from "./Logo";
import { COMPANY } from "../data/site";

const LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/services", label: "Services" },
  { to: "/depannage-urgence", label: "Dépannage" },
  { to: "/a-propos", label: "À propos" },
  { to: "/realisations", label: "Réalisations" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => setOpen(false), [loc.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-2xl bg-white/85 border-b border-navy/5 shadow-sm" : "bg-white/40 backdrop-blur-md"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 flex items-center justify-between h-20">
        <Logo />
        <nav className="hidden lg:flex items-center gap-1">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]/g, "")}`}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-semibold rounded-full transition-colors ${
                  isActive ? "text-brand" : "text-navy/70 hover:text-navy"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`tel:${COMPANY.phoneRaw}`}
            data-testid="nav-call-btn"
            className="flex items-center gap-2 text-navy font-bold text-sm hover:text-brand transition-colors"
          >
            <Phone className="w-4 h-4" /> {COMPANY.phone}
          </a>
          <Link
            to="/devis"
            data-testid="nav-quote-btn"
            className="bg-brand hover:bg-brand-dark text-white font-bold text-sm py-3 px-6 rounded-full shadow-lg shadow-brand/20 transition-colors"
          >
            Devis gratuit
          </Link>
        </div>
        <button
          className="lg:hidden text-navy p-2"
          onClick={() => setOpen((o) => !o)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-navy/5 px-5 py-6 space-y-1 animate-fade-up" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `block px-4 py-3 rounded-xl font-semibold ${
                  isActive ? "bg-brand/10 text-brand" : "text-navy/80 hover:bg-navy/5"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/devis" className="block text-center mt-3 bg-brand text-white font-bold py-3.5 rounded-full">
            Demander un devis gratuit
          </Link>
          <a href={`tel:${COMPANY.phoneRaw}`} className="block text-center mt-2 border-2 border-navy/10 text-navy font-bold py-3.5 rounded-full">
            Appeler le {COMPANY.phone}
          </a>
        </div>
      )}
    </header>
  );
}
